module.exports = __webpack_public_path__ + "img/7b50b91.jpg";